<p>special-wager-races works!</p>
